import React, { useEffect } from 'react'
import ReactGA from 'react-ga'

const NotFound = () => {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search)
  }, [])

  return <div>404 / Not Found</div>
}

export default NotFound
